export default [
  {
    /*金融机构下拉列表*/
    name: 'creditAccessAgencySelectList',
    method: 'post',
    url: '/finhub/front/creditAccess/creditAccessAgencySelectList',
  },
  {
    /* 产品 */
    name: 'creditAccessProductSelectList',
    method: 'post',
    url: '/finhub/front/creditAccess/creditAccessProductSelectList',
  },
  {
    /* 授信查询记录 */
    name: 'pageQueryCreditAccess',
    method: 'post',
    url: '/finhub/front/creditAccess/pageQueryCreditAccess',
  },
  {
    /* 融资进度查询列表 */
    name: 'pageQueryFinanceScheduleList',
    method: 'post',
    url: '/finhub/front/finance/query/pageQueryFinanceScheduleList',
  },
  {
    /* 融资进度详情 */
    name: 'financeScheduleDetail',
    method: 'post',
    url: '/finhub/front/finance/query/financeScheduleDetail',
  },
  {
    /* 融资进度产品 */
    name: 'financeScheduleListOptProduct',
    method: 'post',
    url: '/finhub/front/finance/query/financeScheduleListOptProduct',
  },
  {
    /* 融资进度机构 */
    name: 'financeScheduleListOptAgency',
    method: 'post',
    url: '/finhub/front/finance/query/financeScheduleListOptAgency',
  },
]
